import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import zhLocal from "./lang/zh.js";
import enLocal from "./lang/en.js";

const i18n = new VueI18n({
  locale: "zh",
  messages: {
    en: { ...enLocal },
    zh: { ...zhLocal },
  },
  silentTranslationWarn: true,
});

export default i18n;
